module.exports = __webpack_public_path__ + "img/mobile-logo.9efbf347.svg";